/*
  Quuve LP7 Hero — 背景写真の subtle parallax(scroll + pointer)
  - 商品画像・コピーは対象外(固定のまま)
  - data-depth (0.08〜0.12程度) で写真ごとの移動量を調整
  - 調整パラメータ: SCROLL_MAX_PX / POINTER_MAX_PX / MOBILE_SCALE / EASING
  - prefers-reduced-motion: reduce の場合は完全に無効化
*/
(function () {
  var SCROLL_MAX_PX = 24; // スクロールによる縦移動の最大値(px)
  var POINTER_MAX_PX = 16; // マウス追従による横移動の最大値(px)
  var MOBILE_SCALE = 0.4; // モバイル(<768px)での動き量の縮小率
  var EASING = 0.12; // 値が大きいほど追従が速い(0〜1)

  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotionQuery.matches) return;

  var cards = document.querySelectorAll('.lp7-hero-bgphoto[data-parallax]');
  if (!cards.length) return;

  var items = Array.prototype.map.call(cards, function (el) {
    return {
      el: el,
      depth: parseFloat(el.getAttribute('data-depth')) || 0.1,
      targetX: 0,
      targetY: 0,
      currentX: 0,
      currentY: 0
    };
  });

  var heroCard = document.querySelector('.lp7-hero-card');
  var isMobile = window.matchMedia('(max-width: 767px)').matches;
  var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var heroInitialOffset = null;
  var rafId = null;

  function getHeroOffset() {
    if (!heroCard) return 0;
    var rect = heroCard.getBoundingClientRect();
    return rect.top + window.scrollY;
  }

  function updateScrollTargets() {
    if (heroInitialOffset === null) heroInitialOffset = getHeroOffset();
    var scale = isMobile ? MOBILE_SCALE : 1;
    var delta = window.scrollY - heroInitialOffset;

    items.forEach(function (item) {
      var y = delta * item.depth * scale;
      y = Math.max(Math.min(y, SCROLL_MAX_PX), -SCROLL_MAX_PX);
      item.targetY = y;
    });
  }

  function updatePointerTargets(event) {
    if (!heroCard || !hasHover) return;
    var rect = heroCard.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;
    var normX = (event.clientX - centerX) / (rect.width / 2);
    var normY = (event.clientY - centerY) / (rect.height / 2);

    items.forEach(function (item) {
      var x = normX * POINTER_MAX_PX * item.depth * 6;
      x = Math.max(Math.min(x, POINTER_MAX_PX), -POINTER_MAX_PX);
      item.targetX = x;
    });
  }

  function resetPointerTargets() {
    items.forEach(function (item) {
      item.targetX = 0;
    });
  }

  function tick() {
    items.forEach(function (item) {
      item.currentX += (item.targetX - item.currentX) * EASING;
      item.currentY += (item.targetY - item.currentY) * EASING;
      item.el.style.transform = 'translate3d(' + item.currentX.toFixed(2) + 'px, ' + item.currentY.toFixed(2) + 'px, 0)';
    });
    rafId = window.requestAnimationFrame(tick);
  }

  window.addEventListener('scroll', updateScrollTargets, { passive: true });
  window.addEventListener('resize', function () {
    isMobile = window.matchMedia('(max-width: 767px)').matches;
    hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    heroInitialOffset = null;
    updateScrollTargets();
  });

  if (hasHover && heroCard) {
    heroCard.addEventListener('pointermove', updatePointerTargets);
    heroCard.addEventListener('pointerleave', resetPointerTargets);
  }

  reduceMotionQuery.addEventListener('change', function (event) {
    if (event.matches && rafId) {
      window.cancelAnimationFrame(rafId);
      items.forEach(function (item) {
        item.el.style.transform = '';
      });
    }
  });

  updateScrollTargets();
  tick();
})();
